// components/SearchInput.tsx
import React from 'react';

interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder: string;
    showClearButton?: boolean;
    className?: string;
    showResultsCount?: boolean;
    resultsCount?: number;
    totalCount?: number;
}

export const SearchInput: React.FC<SearchInputProps> = ({
    value,
    onChange,
    placeholder,
    showClearButton = true,
    className = "input",
    showResultsCount = false,
    resultsCount = 0,
    totalCount = 0
}) => {
    return (
        <div className="search-container">
            <input
                type="text"
                className={className}
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
            
            {showResultsCount && value && (
                <div className="search-results-info">
                    Showing {resultsCount} of {totalCount} results
                    {showClearButton && (
                        <button 
                            onClick={() => onChange('')}
                            className="clear-search-btn"
                            type="button"
                        >
                            Clear
                        </button>
                    )}
                </div>
            )}
            
            {!showResultsCount && showClearButton && value && (
                <button 
                    onClick={() => onChange('')}
                    className="clear-search-btn"
                    type="button"
                >
                    Clear
                </button>
            )}
        </div>
    );
};